import {AfterViewInit, Component, OnInit, OnDestroy, ViewChild, ElementRef, inject} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {HelperService} from '../services/helper.service';

@Component({
  template: ''
})
export abstract class ModalComponent<T = any> implements AfterViewInit, OnInit, AfterViewInit, OnDestroy {
  HelperService = HelperService;
  modalController: ModalController;
  public helperService = HelperService;
  @ViewChild('body') ionRouterOutlet: ElementRef;

  elRef = inject(ElementRef);

  private _item: T = undefined;

  get item(): any {
    return this._item;
  }

  set item(value: any) {
    this._item = value;
    if (this._item === null) {
      this.closeModal();
    }
  }

  constructor(
    modalController: ModalController
  ) {
    this.modalController = modalController;
  }

  ngAfterViewInit(): void {
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  ionViewDidEnter() {
  }

  closeModal(data: any = null) {
    return this.modalController.dismiss(data, null, this.elRef.nativeElement.parentElement.id);
  }

  //
  // closeAllModal(data: any = null) {
  //   for (let i = 0; i < this.modalService.modalInst.length; i++) {
  //     this.modalService.modalInst[i].dismiss(data);
  //   }
  //   this.modalService.modalInst = [];
  //   this.modalService.modalIncr = 0;
  // }
}
